import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { validations } from "../../../../../config/validations/validations";

export const formItems = {
  name: {
    name: "title",
    label: "Name",
    rules: [
      validations.required.text(),
      validations.min.text(3),
      validations.max.text(50),
    ],
  },
  designation: {
    name: "subtitle",
    label: "Designation",
    rules: [
      validations.required.text(),
      validations.min.text(3),
      validations.max.text(400),
    ],
  },
  description: {
    name: "description",
    label: "Description",
    rules: [
      validations.required.text(),
      validations.min.text(3),
      validations.max.text(400),
    ],
  },
};

/**
 * Renders a form component for creating or editing a testimonial record.
 *
 * @param {Object} props - The props object.
 * @param {FormInstance} props.form - The form instance.
 * @param {string} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle changes in form values.
 * @param {Object} props.editValues - The values to pre-fill the form with for editing.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  useEffect(() => {
    if (editValues) {
      form.setFieldsValue(editValues);
    }
  }, [editValues, form]);

  const onFinish = (data: any) => {
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Text {...formItems.name} />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <InputBox.Text {...formItems.designation} />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.TextArea {...formItems.description} autoSize />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
